import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle1" }, "Assign to Users (Optional)", -1)
const _hoisted_2 = { class: "q-mt-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Assigning to:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_users_list = _resolveComponent("users-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_q_separator, { class: "q-mb-sm" }),
    _createVNode(_component_q_input, {
      modelValue: _ctx.keyword,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
      placeholder: "Search by name or email",
      autocomplete: "no",
      clearable: "",
      "clear-icon": "fa fa-times",
      dense: "",
      filled: "",
      class: "q-mb-md"
    }, {
      prepend: _withCtx(() => [
        _createVNode(_component_q_icon, {
          name: "fa fa-search",
          size: "xs",
          color: "primary"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_users_list, {
      "account-id": _ctx.accountId,
      keyword: _ctx.keyword,
      "exclude-self": "",
      selected: _ctx.modelValue,
      onSelection: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, null, 8, ["account-id", "keyword", "selected"]),
    _withDirectives(_createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.assigningTo), 1)
    ], 512), [
      [_vShow, _ctx.modelValue.length]
    ])
  ]))
}